export const GoogleOAuthclientId = "338736371120-medbekb657rdvnaem917ag695un22plo.apps.googleusercontent.com";
